import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

const spacerVariants = cva([], {
  variants: {
    variant: {
      xxs: 'pt-s-spacer-xxs md:pt-d-spacer-xxs',
      xs: 'pt-s-spacer-xs md:pt-d-spacer-xs',
      sm: 'pt-s-spacer-sm md:pt-d-spacer-sm',
      md: 'pt-s-spacer-md md:pt-d-spacer-md',
      lg: 'pt-s-spacer-lg md:pt-d-spacer-lg',
      xl: 'pt-s-spacer-xl md:pt-d-spacer-xl',
      xxl: 'pt-s-spacer-2xl md:pt-d-spacer-2xl'
    }
  },
  defaultVariants: {
    variant: 'xl'
  }
})

export type SpacerProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof spacerVariants> & {
    is_liquid?: boolean
    theme?: 'light' | 'dark' | string
  }

const Spacer = ({ className, variant, theme, ...props }: SpacerProps) => {
  return (
    <Section
      className={cn(spacerVariants({ variant, className }))}
      theme={theme}
      {...props}
    >
      <hr className="border-0" />
    </Section>
  )
}

export default Spacer
